/* tslint:disable */
/* eslint-disable */
/**
 * Lightly API
 * Lightly.ai enables you to do self-supervised learning in an easy and intuitive way. The lightly.ai OpenAPI spec defines how one can interact with our REST API to unleash the full potential of lightly.ai
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@lightly.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelEnumInterfaces.mustache
// synched 02.02.2023
import * as yup from 'yup';
import * as fastJSON from 'fast-json-stringify';
import { StringSchema } from 'fast-json-stringify';
/**
 *
 * @export
 * @enum {string}
 */
export enum TeamRole {
    OWNER = 'OWNER',
    ADMIN = 'ADMIN',
    MEMBER = 'MEMBER',
    SERVICEACCOUNT = 'SERVICEACCOUNT'
}
/* LIGHTLY CUSTOM START -> modelEnumInterfaces */
export const TeamRoleValidatorShape = [
    'OWNER',
    'ADMIN',
    'MEMBER',
    'SERVICEACCOUNT'
];
export const TeamRoleValidator = yup.mixed().oneOf(TeamRoleValidatorShape);
export const TeamRoleStringifyShapeProperties = {};
export const TeamRoleStringifyShape: StringSchema = {
    title: 'TeamRole Stringifier',
    type: 'string'
};
export const TeamRoleStringify = (typeof process === 'object' && String(process) === '[object process]') ?
    fastJSON.build(TeamRoleStringifyShape)
    :
        () => { throw new Error('fast-json-stringify only works in nodejs'); };
/* LIGHTLY CUSTOM END */
export function TeamRoleFromJSON(json: any): TeamRole {
    return TeamRoleFromJSONTyped(json, false);
}
export function TeamRoleFromJSONTyped(json: any, ignoreDiscriminator: boolean): TeamRole {
    return json as TeamRole;
}
export function TeamRoleToJSON(value?: TeamRole | null): any {
    return value as any;
}
